/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { isError } from "@epic-mw/error-types";

import { getApiPath } from "../utils";

import { DownloadRequest } from "./sdk.types";

export const fetchSdkDownload = async (request: DownloadRequest, serverUrl?: string): Promise<void> => {
	try {
		const params = new URLSearchParams();
		if (request.archive_id) {
			params.append("archive_id", request.archive_id.toString());
		}
		if (request.archive_type) {
			params.append("archive_type", request.archive_type);
		}

		const url = `${getApiPath(serverUrl)}/sdk/download?${params.toString()}`;
		const response = await fetch(url, {
			method: "POST",
		});

		if (!response.ok) {
			throw new Error(`Download failed with status: ${response.status}`);
		}

		// If the response is a redirect, we need to handle it
		if (response.redirected) {
			// The download URL is in the Location header
			const downloadUrl = response.url;
			// Open the download URL in a new window/tab
			window.open(downloadUrl, "_blank");
		}
	} catch (err) {
		console.error("fetchSdkDownload() failed to load", isError(err) && err.message);
		throw err;
	}
};
